import { Node } from '@tiptap/core'

export const Figcaption = Node.create({
    name: 'figcaption',
    content: 'inline*',
    group: 'block',
    defining: true,

    addAttributes() {
        return {
            'data-placeholder': {
                default: null,
            },
        }
    },

    parseHTML() {
        return [{ tag: 'figcaption' }]
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'figcaption',
            {
                class: 'editor-figcaption',
                ...HTMLAttributes,
            },
            0,
        ]
    },
})
